import BoxContainer from "../BoxContainer";
import TextSection from "./TextSection";

// TODO: Type this. Maybe use Strapi generated types?
// https://docs.strapi.io/dev-docs/typescript#generate-typings-for-project-schemas
interface TextBodyProps {
	components: any[];
	variables?: Record<string, any>;
}

/**
 * Renders the output from the Strapi API for a "Dynamic zone" field.
 *
 * Strapi's "Dynamic zone" field allows you to create a list of component instances,
 * where each component is one of a set of types specified in the field definition.
 * Currently this is just used for the Tuition page "body" field, which is a list
 * of "Text Section" and "Infobox" components.
 *
 * See TextBody.stories.tsx for an example.
 *
 * @param param0
 * @returns
 */
const TextBody: React.FC<TextBodyProps> = ({components, variables}) => {
	return (
		<div className="flex flex-col gap-6">
			{components.map((component, i) => {
				switch (component.__component) {
					case "page-components.text-section":
						return (
							<TextSection
								key={"text-section-" + component.id}
								contents={component.content}
								variables={variables}
							/>
						);
					case "page-components.infobox":
						return (
							<BoxContainer key={"infobox-" + component.id}>
								<TextSection
									contents={component.content}
									variables={variables}
								/>
							</BoxContainer>
						);
					default:
						return <div key={i}>Unknown component</div>;
				}
			})}
		</div>
	);
};

export default TextBody;
